export default "__VITE_ASSET__D9E7w6kH__"